export default __webpack_public_path__ + "static/media/bubble_nova_s1.be704ec7.png";